module.exports = __webpack_public_path__ + "img/f_25_03.1e7fddd0.jpg";